import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	selfMentionWrapper: {
		borderColor: 'transparent',
		borderRadius: token('border.radius.100'),
		boxShadow: token('elevation.shadow.overlay'),
		color: token('color.text.inverse'),
	},
	mentionWrapper: {
		borderColor: 'transparent',
		borderRadius: token('border.radius.100'),
	},
});

export const MentionComponent = ({ name, isUserSelf }) => {
	return isUserSelf ? (
		<Box
			as="span"
			backgroundColor="color.background.brand.bold"
			padding="space.025"
			xcss={styles.selfMentionWrapper}
		>
			{name}
		</Box>
	) : (
		<Box
			as="span"
			backgroundColor="color.background.neutral"
			padding="space.025"
			testId="mention-component"
			xcss={styles.mentionWrapper}
		>
			{name}
		</Box>
	);
};
